export default function getCharacterDiffCount(firstString, secondString) {
    const maxStringLength = Math.max(firstString.length, secondString.length);
    let diffCount = 0;

    for (let charIndex = 0; charIndex < maxStringLength; charIndex++) {
        if (firstString[charIndex] !== secondString[charIndex]) {
            diffCount++;
        }
    }
    return diffCount;
}
